import type { UseActionResult } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Logistic, VoidLogisticShippingLabelArgs } from '@ztechapps/common.contract'
import { voidLogisticShippingLabelQuery } from './graphql'

export type UseVoidLogisticShippingLabelResult = UseActionResult<Logistic, VoidLogisticShippingLabelArgs>

export const useVoidLogisticShippingLabel = (): UseVoidLogisticShippingLabelResult =>
  useActionMutation<Logistic, VoidLogisticShippingLabelArgs>({ query: voidLogisticShippingLabelQuery })
